import { motion } from "framer-motion";
import { defaultBgVariants, defaultPanelVariants } from "./defaultValues";

interface ConfirmPrimaryPopUpProps {
  title: string;
  paragraphs: string[];
  options: { text: string; onClick: () => void }[];
  handleClosePopUp: () => void;
}

const ConfirmPrimaryPopUp: React.FC<ConfirmPrimaryPopUpProps> = ({
  title,
  paragraphs,
  options,
  handleClosePopUp,
}) => {
  return (
    <>
      <motion.div
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-10 flex flex-col flex-grow"
        variants={defaultBgVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3, ease: "easeOut" }}
        onClick={handleClosePopUp}
      />
      <motion.div
        className="fixed w-[440px] h-[380px] left-0 right-0 ml-auto mr-auto bottom-5 p-6 border bg-white rounded-3xl flex-col justify-start items-center gap-10 inline-flex z-30"
        variants={defaultPanelVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <div className="h-[332px] flex-col justify-start items-start gap-6 flex">
          <div className="self-stretch h-48 flex-col justify-start items-start gap-6 flex">
            <div className="self-stretch h-7 flex-col justify-start items-start gap-3 flex">
              <div className="self-stretch justify-center items-center gap-3 inline-flex">
                <div className="grow shrink basis-0 text-neutral-700 text-[23px] font-semibold font-sans leading-7">
                  {title}
                </div>
              </div>
            </div>
            {paragraphs.map((paragraph: string, index: number) => {
              return (
                <div
                  key={index}
                  className="self-stretch justify-start items-start gap-2 inline-flex"
                >
                  <div className="grow shrink basis-0 text-neutral-700 text-base font-normal font-sans leading-7">
                    {paragraph}
                  </div>
                </div>
              );
            })}
          </div>
          {options.map(
            (option: { text: string; onClick: () => void }, index: number) => {
              return (
                <div
                  key={index}
                  className="self-stretch h-[46px] px-5 py-3 rounded justify-center items-center gap-2 inline-flex"
                >
                  <button
                    className="text-secondary-600 hover:underline text-lg font-semibold font-sans leading-snug cursor-pointer"
                    onClick={option.onClick}
                  >
                    {option.text}
                  </button>
                </div>
              );
            }
          )}
        </div>
      </motion.div>
    </>
  );
};

export default ConfirmPrimaryPopUp;
